<template>
	<div>
		<div class="me-question">
			<div class="empty-img" v-if="data.length==0">
        <img src="./qa.png"/>
        <p>暂无问答</p>
      </div>
			<ul class="me-question-items" v-dt-infinite-scroll="getData">
				<!--<li class="me-question-item me-question-item-ask">
					<div class="me-question-board">我的提问</div>
					<div class="me-question-title o1">老师，如何才能？什么什么什么什么什么什么什么</div>
					<div class="me-question-ask-text">我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容我的问题内容</div>
					<div class="me-question-info f-cb">
						<div class="me-question-time">更新于 2018.08.02</div>
						<div class="me-question-all">全部3个回答></div>
					</div>
					<div class="me-question-close">×</div>
				</li>
				<li class="me-question-item me-question-item-answer">
					<div class="me-question-board">我的回答</div>
					<div class="me-question-answer-text">我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答我的回答</div>
					<div class="me-question-ask o1">题目：题目题目题目题目题目题目题目题目题目题目题目题目题目</div>
					<div class="me-question-info f-cb">
						<div class="me-question-time">更新于 2018.08.02</div>
						<div class="me-question-all">全部3个回答></div>
					</div>
					<div class="me-question-close">×</div>
				</li>-->
				<template v-for="(item,index) in data">
					<li class="me-question-item me-question-item-ask" v-if="item.question_id">
						<div class="me-question-board">我的提问</div>
						<div class="me-question-title o1" @click="toQuestion(item.question_id)" v-html="item.title"></div>
						<div class="me-question-ask-text" @click="toQuestion(item.question_id)" v-html="item.content"></div>
						<div class="me-question-info f-cb">
							<div class="me-question-time">更新于 {{tools.timestampConversion(item.create_time)}}</div>
							<!--<div class="me-question-all">全部3个回答></div>-->
						</div>
						<div class="me-question-close" @click="deleteAsk(index)">×</div>
					</li>
					<li class="me-question-item me-question-item-answer" v-else-if="item.answer_id">
						<div class="me-question-board">我的回答</div>
						<div class="me-question-answer-text" @click="toQuestion(item.qustion_id)" v-html="item.content"></div>
						<div class="me-question-ask o1" @click="toQuestion(item.qustion_id)" v-html="item.question_content"></div>
						<div class="me-question-info f-cb">
							<div class="me-question-time">更新于 2018.08.02</div>
							<!--<div class="me-question-all">全部3个回答></div>-->
						</div>
						<div class="me-question-close" @click="deleteAnswer(index)">×</div>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
	import _ from "lodash";
	export default{
		data(){
			return{
				answerData:[],
				askData:[],
				data:[]
			}
		},
		methods:{
			getData(page){
				//从我的回答和我的提问中各取五条按时间排序
        var length=5;
        var askData=this.askData,
          answerData=this.answerData;
        var answerPromise=this.$api.get("",{
          api:"/v1/my/myQuestion",
          user_type:this.tools.getStorage("user_type"),
          len:length,
          page
        },res=>{
          answerData=res.data;
        })
        var askPromise=this.$api.get("",{
          api:"/v1/my/myAnswer",
          user_type:this.tools.getStorage("user_type"),
          len:length,
          page
        },res=>{
          askData=res.data;
        })
        return new Promise((resolve,reject)=>{
          //问答都拿到后
          Promise.all([answerPromise,askPromise]).then(()=>{
            //合并两个数组
            var	arr=answerData.concat(askData);
            //先按创建时间排序，然后存入this.data
            this.data=this.data.concat(_.sortBy(arr,item=>arr.create_time));
            //问答的数量都小于想要请求的数量length，代表没有更多内容了
            if(answerData.length<length && askData.length<length){
              reject();
            }
            else{
              resolve();
            }
          })
        })
			},
			deleteAsk(index){
				var deleteItem=this.data[index];
				this.$messagebox.confirm("确认删除吗？").then(()=>{
					this.$api.get("",{
						api:"/v1/question_answer/delete",
						user_type:this.tools.getStorage("user_type"),
						question:deleteItem.question_id
					},res=>{
						this.data.splice(index,1);
						this.$toast("删除成功！");
					});
				});
			},
			deleteAnswer(index){
				var deleteItem=this.data[index];
				this.$messagebox.confirm("确认删除吗？").then(()=>{
					this.$api.get("",{
						api:"/v1/question_answer/del_answer",
						user_type:this.tools.getStorage("user_type"),
						answer_id:deleteItem.answer_id
					},res=>{
						this.data.splice(index,1);
						this.$toast("删除成功！");
					});
				});
			},
			toQuestion(id){
				this.$router.push("/answer/"+id);
			}
		}
	}
</script>

<style>
	.me-question-items{
		padding-top:0.133rem;
	}
	.me-question-item{
		position: relative;
		padding:0.4rem 0;
		margin:0 0.4rem;
		border-bottom: 1px solid #e6e6e6;
	}
	.me-question-board{
		width:1.706rem;
		height:0.56rem;
		border-radius: 0.106rem;
		text-align: center;
		line-height: 0.56rem;
		color:#fff;
	}
	.me-question-item-ask .me-question-board{
		background:#EC6D3A;
	}
	.me-question-item-answer .me-question-board{
		background:#3192E0;
	}
	.me-question-title{
		margin-top:0.24rem;
		font-size: 0.426rem;
		color:#333;
	}
	.me-question-ask-text{
		margin-top:0.266rem;
		font-size: 0.346rem;
		line-height: 0.533rem;
		color:#666;
	}
	.me-question-info{
		margin-top:0.306rem;
		font-size: 0.266rem;
		line-height:0.266rem;
		color:#999;
	}
	.me-question-time{
		float:left;
	}
	.me-question-all{
		float:right;
	}
	.me-question-close{
		position: absolute;
		right:-0.3rem;
		top:0.233rem;
		width:1rem;
		height:1rem;
		text-align: center;
		line-height:1rem;
		font-size: 0.4rem;
		color:#ccc;
	}
	.me-question-answer-text{
		margin-top:0.16rem;
		font-size: 0.346rem;
		line-height:0.533rem;
		color:#333;
	}
	.me-question-ask{
		margin-top:0.266rem;
		font-size: 0.426rem;
		color:#999;
	}
	.infinite-scroll-text{
		height:0.533rem;
		line-height: 0.533rem;
		font-size: 0.346rem;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/me-question/me-question.vue